import { FC, RefObject } from 'react'
import { Text, TextProps } from 'react-native'
import { UnistylesVariants, createStyleSheet, useStyles } from 'react-native-unistyles'

type HeadingProps = TextProps &
    UnistylesVariants<typeof stylesheet> & { ref?: RefObject<Text | null> }

const Heading: FC<HeadingProps> = ({ children, variant = 'h1', style, ref, ...props }) => {
    const { styles } = useStyles(stylesheet, { variant })

    return (
        <Text {...props} style={[styles.heading, style]} ref={ref}>
            {children}
        </Text>
    )
}

const stylesheet = createStyleSheet((theme) => ({
    heading: {
        fontFamily: theme.fonts.medium,
        variants: {
            variant: {
                h1: {
                    fontSize: 30,
                },
                h2: {
                    fontSize: 24,
                },
                h3: {
                    fontSize: 20,
                },
                h4: {
                    fontSize: 18,
                },
                h5: {
                    fontSize: 16,
                },
            },
        },
    },
}))

export default Heading
